module.exports = __webpack_public_path__ + "static/img/Sid-Draper.2550404.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Sid-Draper.jpg
// module id = fYL9
// module chunks = 0